<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'SFTP'"></Teranet-PageTitle>
    <form [formGroup]="sftpForm"
          #createform="ngForm"
          (ngSubmit)="createSftp(createform)"
          novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'SFTP Setup'" [IconName]="'calendar'"></Teranet-ClientTitle>
          </div>
          <div fxLayout.xs="column" fxLayout="row wrap">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Host Name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="hostname" required />
                <mat-error *ngIf="sftpForm.get('hostname').hasError('required') || sftpForm.get('hostname').hasError('whitespace')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">SFTP Name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="sftpname" required />
                <mat-error *ngIf="sftpForm.get('sftpname').hasError('required') || sftpForm.get('sftpname').hasError('whitespace')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Port</mat-label>
              <mat-form-field appearance="outline">
                <input matInput #txtEmailVal data-lpignore="true" formControlName="port" required />
                <mat-error *ngIf="sftpForm.get('port').hasError('required')">
                  Required
                </mat-error>
                <mat-error *ngIf="sftpForm.get('port').hasError('pattern')">
                  Please input a number
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout.xs="column" fxLayout="row wrap">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">User Name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="username" autocomplete="new-password" required />
                <mat-error *ngIf="sftpForm.get('username').hasError('required') || sftpForm.get('username').hasError('whitespace')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Password</mat-label>
              <mat-form-field appearance="outline">
                <input matInput
                       data-lpignore="true"
                       formControlName="password"
                       [type]="hide ? 'password' : 'text'"
                       autocomplete="new-password"
                       required />
                <mat-icon matSuffix (click)="hide = !hide">
                  {{
                  hide ? 'visibility_off' : 'visibility'
                  }}
                </mat-icon>
                <mat-error *ngIf="sftpForm.get('password').hasError('required') || sftpForm.get('password').hasError('whitespace')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-checkbox formControlName="isexternal" class="checkbox-margin">Is External</mat-checkbox>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button-lg" type="reset">Reset</button>
            <button mat-raised-button class="theme-button-lg" type="submit">Add</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="sftps"
                            [gridName]="'sftp-list'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="GridDefaultSettings()"
                            [isFinishLoading]="true"
                            [isExportExcel]="false"
                            [pageName]="'sftp-list'"></Teranet-CustomizedGrid>
  </div>
</div>
